<template>
  <!-- platform -->
  <div class="platform">
    <div class="platform_box">
      <div class="top">
        <div class="left">
          <div class="text_box">
            <img class="img" src="../../assets/puKanBan/baojing.png">
            <div class="txt">
              <span @click="getList">今日预警数</span>
              <span>{{list.earlyWarningByDay}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img" src="../../assets/puKanBan/baojing.png">
            <div class="txt">
              <span>本周预警数</span>
              <span>{{list.earlyWarningByWeek}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img" src="../../assets/puKanBan/baojing.png">
            <div class="txt">
              <span>本月预警数</span>
              <span>{{list.earlyWarningByMon}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img" src="../../assets/puKanBan/baojing.png">
            <div class="txt">
              <span>总预警数</span>
              <span>{{list.earlyWarningTotal}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img2" src="../../assets/kanban/4.png">
            <div class="txt">
              <span>今日未处理数</span>
              <span>{{list.untreatedByDay}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img2" src="../../assets/kanban/4.png">
            <div class="txt">
              <span>未处理总数</span>
              <span>{{list.untreatedTotal}}个</span>
            </div>
          </div>

        </div>
        <div class="right">
          <div class="text_box">
            <img class="img" src="../../assets/bulletinBoard/4.png">
            <div class="txt">
              <span>监测设备数</span>
              <span>{{list.detectionDeviceTotal}}个</span>
            </div>
          </div>
          <div class="text_box">
            <img class="img" src="../../assets/bulletinBoard/4.png">
            <div class="txt">
              <span>监测点位数</span>
              <span>{{list.detectionDit}}个</span>
            </div>
          </div>

        </div>
      </div>
      <div class="pie" :style="{height:(heights/100*39.2)+'px'}">
        <div class="left">
          <div class="titled">监测设备占比</div>
          <vchart ref='vchartPie' style="width: 100%;height: 100%;"></vchart>
        </div>
        <div class="right">
          <div class="titled">局放设备类型占比</div>
          <!-- <div class="txt">
            <div class="num">{{total}}</div>
            <div class="t">总设备数(台)</div>
          </div> -->
          <vchart ref='vchartPie2' style="width: 100%;height: 100%;"></vchart>
        </div>
      </div>
      <div class="line" :style="{height:(heights/100*28.7)+'px'}">
        <el-radio-group v-model="radio" class="grouped" @change="changeFn">
          <el-radio :label="0">日</el-radio>
          <el-radio :label="1">周</el-radio>
          <el-radio :label="2">月</el-radio>
          <el-radio :label="3">年</el-radio>
        </el-radio-group>
        <vchart ref='vchartPie3' style="width: 100%;height: 100%;"></vchart>
      </div>
      <div class="line">
        <el-table id="demo" stripe :data="tableData" :height="heights/100*24" max-height="300px" style="width: 100%"
          row-key="id" border>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="index" label="序号" width="60" align="center">
          </el-table-column>
          <el-table-column label="监测设备" prop="deviceName" min-width="110" />
          <el-table-column label="监测点位" prop="devicePoint" min-width="110" />
          <el-table-column label="预警内容" prop="description" min-width="190" />
          <el-table-column label="处理照片" width="90">
            <template #default="{row}">

              <el-image style="width: 50px; height: 50px" :src="row.picture" :preview-src-list="[row.picture]">
              </el-image>
            </template>
          </el-table-column>
          <el-table-column label="预警时间" min-width="110">
            <template #default="{row}">
              <span>{{row.time | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理人" prop="confirmuser" min-width="110" />
          <el-table-column label="处理时间" min-width="110">
            <template #default="{row}">
              <span>{{row.confirmtime | date_format}}</span>
            </template>
          </el-table-column>
          <el-table-column label="处理结论" prop="conclusion" min-width="110" />
          <el-table-column label="操作" align="center" width="110">
            <template #default="{row}">
              <el-link type="primary" @click="edit_ed(row)">查看</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 新增修改 -->
    <el-dialog title="预警信息处理" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible" width="400"
      center>
      <el-form :model="temp" :rules="rules" ref="temp" label-width="120px" class="demo-temp">
        <el-form-item label="监测设备:">
          <el-input v-model="temp.deviceName" placeholder="请输入监测设备" readonly></el-input>
        </el-form-item>
        <el-form-item label="监测点位:">
          <el-input v-model="temp.devicePoint" placeholder="请输入监测点位" readonly></el-input>
        </el-form-item>
        <el-form-item label="预警内容:">
          <el-input v-model="temp.description" placeholder="请输入预警内容" readonly></el-input>
        </el-form-item>
        <el-form-item label="预警时间:">
          <el-date-picker v-model="temp.time" type="datetime" placeholder="选择日期时间" readonly>
          </el-date-picker>
        </el-form-item>
        <el-form-item label="处理结论:" prop="conclusion">
          <el-input v-model="temp.conclusion" placeholder="请输入处理结论"></el-input>
        </el-form-item>
        <el-form-item label="处理照片:" prop="picture">
          <el-upload action="" :show-file-list="false" :auto-upload="false" accept="image/*" list-type="picture-card"
            :on-change="icon_fn">
            <el-image v-if="temp.picture" :src="temp.picture" class="avatar"></el-image>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="PRPS图谱:">
          <el-button type="success" @click="aaa(temp.jfgraph)">查看</el-button>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">{{temp.conclusion?'返 回':'取 消'}}</el-button>
          <el-button type="primary" @click="submit" v-if="!temp.conclusion">处 理
          </el-button>
        </span>
      </template>
    </el-dialog>

    <el-dialog title="PRPS图谱" :close-on-click-modal='false' v-dialogDrag :visible.sync="dialogVisible2" width="800px"
      center>
      <div id="proportion" style="width: 700px;"></div>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="primary" @click="dialogVisible2 = false">确 定</el-button>
        </span>
      </template>
    </el-dialog>

  </div>
</template>

<script>
  import vchart from '@/components/module/chart/vchart.vue';
  import request from "@/api/http.js";
  import * as echarts from 'echarts';
  import "echarts-gl"
  export default {
    components: {
      vchart,
    },
    filters: {
      eventstateFn (v) {
        if(v===0) {
          return "未处理"
        }
        if(v===1) {
          return "处理中"
        }
        if(v===2) {
          return "已处理"
        }
        if(v===3) {
          return "已忽略"
        }
        return ''
      },
      // 转换时间戳
      date_format (value) { //value就是插值的数据
        if(!value) {
          return ""
        }
        let date=new Date(value);
        let Y=date.getFullYear()+'-';
        let M=(date.getMonth()+1<10? '0'+(date.getMonth()+1):date.getMonth()+1)+'-';
        let D=(date.getDate()<10? '0'+(date.getDate()):date.getDate())+' ';

        let h=(date.getHours()<10? '0'+(date.getHours()):date.getHours())+':';
        let m=(date.getMinutes()<10? '0'+(date.getMinutes()):date.getMinutes())+':';
        let s=(date.getSeconds()<10? '0'+(date.getSeconds()):date.getSeconds());
        let strDate=Y+M+D+h+m+s;
        return strDate
      },
    },
    data () {
      return {
        dialogVisible2: false,
        heights: document.getElementById('app').clientHeight-120,
        total: 0,
        rules: {
          conclusion: [
            {required: true,message: '请输入处理结论',trigger: 'blur'}
          ],
          confirmuser: [
            {required: true,message: '请输入处理人',trigger: 'blur'}
          ],
          description: [
            {required: true,message: '请输入预警内容',trigger: 'blur'}
          ],
          devicePoint: [
            {required: true,message: '请输入监测点位',trigger: 'blur'}
          ],
          deviceName: [
            {required: true,message: '请输入监测设备',trigger: 'blur'}
          ],
          time: [
            {required: true,message: '请选择预警时间',trigger: 'change'}
          ],
          eventstate: [
            {required: true,message: '请选择事件状态',trigger: 'change'}
          ],

        },
        temp: {},
        dialogVisible: false,

        list: {
          "earlyWarningByDay": 0,
          "earlyWarningByWeek": 0,
          "earlyWarningByMon": 6,
          "earlyWarningTotal": 6,
          "untreatedByDay": 0,
          "untreatedTotal": 6,
          "detectionDeviceTotal": 8,
          "detectionDit": null,
          "detectionDeviceNum": null,
          "detectionDeviceProportion": null,
          "undetectedDeviceNum": null,
          "undetectedDeviceProportion": null,
          "partialDischargeDeviceTypeVOS": null,
          "partialDischargeDeviceNumVOS": [
            {
              "dayType": 0,
              "deviceNumByDays": {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0,
                "12": 0,
                "13": 0,
                "14": 0,
                "15": 0,
                "16": 0,
                "17": 0,
                "18": 0,
                "19": 0,
                "20": 0,
                "21": 0,
                "22": 0,
                "23": 0
              }
            },
            {
              "dayType": 1,
              "deviceNumByDays": {}
            },
            {
              "dayType": 2,
              "deviceNumByDays": {
                "1": 0,
                "2": 0,
                "3": 4,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 2,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0,
                "12": 0,
                "13": 0,
                "14": 0,
                "15": 0,
                "16": 0,
                "17": 0,
                "18": 0,
                "19": 0,
                "20": 0,
                "21": 0,
                "22": 0,
                "23": 0,
                "24": 0,
                "25": 0,
                "26": 0,
                "27": 0,
                "28": 0,
                "29": 0,
                "30": 0,
                "31": 0
              }
            },
            {
              "dayType": 3,
              "deviceNumByDays": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 6,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0,
                "11": 0,
                "12": 0
              }
            }
          ],
          "events": [
            {
              "createTime": null,
              "no": 16,
              "type": 7,
              "area": 0,
              "linkobject": "devicestate.局放主机",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712473173000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712473173000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4297421687739121664,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "16"
            },
            {
              "createTime": null,
              "no": 14,
              "type": 7,
              "area": 0,
              "linkobject": "设备串口局放",
              "description": "通道`设备串口局放`中断",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712473172000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712473172000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4297421684073299968,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "14"
            },
            {
              "createTime": null,
              "no": 13,
              "type": 7,
              "area": 0,
              "linkobject": "devicestate.局放主机",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯恢复",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712125854000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712125854000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4295964927744540672,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "13"
            },
            {
              "createTime": null,
              "no": 12,
              "type": 7,
              "area": 0,
              "linkobject": "设备串口局放",
              "description": "通道`设备串口局放`恢复",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712125835000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712125835000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4295964846198882304,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "12"
            },
            {
              "createTime": null,
              "no": 3,
              "type": 7,
              "area": 0,
              "linkobject": "devicestate.局放主机",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712111145000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712111145000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4295903231831179264,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "3"
            },
            {
              "createTime": null,
              "no": 1,
              "type": 7,
              "area": 0,
              "linkobject": "设备串口局放",
              "description": "通道`设备串口局放`中断",
              "confirmtime": null,
              "confirmuser": "",
              "time": 1712111144000,
              "creator": "",
              "value": -107374200,
              "eventtime": 1712111144000,
              "linkdevice": -858993460,
              "eventstate": 0,
              "ticketid": null,
              "ignorereason": null,
              "eventlevel": null,
              "uuid": 4295903227821424640,
              "typeName": null,
              "mainId": null,
              "currentValue": null,
              "deviceType": null,
              "picture": null,
              "conclusion": null,
              "entityName": "Events",
              "id": "1"
            }
          ]
        },
        tableData: [],
        radio: 0,
        roundOption: {
          title: {
            text: '2326',
            subtext: '设备总数(台)',
            left: '25.6%',
            top: '38%',
            textAlign: 'center',
            subtextStyle: {
              color: '#666',
              fontSize: 13,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#000',
            }
          },

          legend: {
            icon: "roundRect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度 
            orient: 'vertical',
            right: '6%',
            top: 'center',
            itemGap: 24,
            formatter: function(name) {
              if(name.length==4) {
                return name+`   367`;
              } else {
                return name+`      36`;
              }

            },
            textStyle: { // 图例的公用文本样式。
              fontSize: 13,
              color: '#000'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)  ({d}%)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: true,
                formatter: '{b}:{c}(台)  ({d}%)'
              },
              data: [
                {
                  value: 10,
                  name: '已检测设备数量'
                },
                {
                  value: 20,
                  name: '未检测设备数量'
                },
              ],
              color: ["#3c90f7","#55bfc0",'#5ebe67'],
              radius: ['57%','70%'],
              center: ['27%','50%'],
            }
          ]
        },
        roundOption2: {
          title: {
            text: '2326',
            subtext: '设备总数(台)',
            left: '25.6%',
            top: '38%',
            textAlign: 'center',
            subtextStyle: {
              color: '#666',
              fontSize: 13,
              lineHeight: 0,
            },
            textStyle: {                  // 图例的公用文本样式。
              fontSize: 20,
              color: '#000',
            }
          },

          legend: {
            icon: "roundRect", //  这个字段控制形状  类型包括 circle， ，roundRect，triangle，diamond，pin，arrow，none
            itemWidth: 12, // 设置宽度
            itemHeight: 12, // 设置高度 
            orient: 'vertical',
            right: '6%',
            top: 'center',
            itemGap: 24,
            formatter: function(name) {
              if(name.length==4) {
                return name+`   367`;
              } else {
                return name+`      36`;
              }

            },
            textStyle: { // 图例的公用文本样式。
              fontSize: 13,
              color: '#000'
            }
          },

          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}(台)'
          },
          series: [
            {
              type: 'pie',
              label: {
                show: true,
                formatter: '{b}:{c}(台)'
              },
              data: [
                {
                  value: 10,
                  name: '检测设备占比'
                },
                {
                  value: 20,
                  name: '未检测设备占比'
                },
              ],

              color: ["#3c90f7","#55bfc0",'#5ebe67','#f6c958'],
              radius: ['57%','70%'],
              center: ['27%','50%'],
            }
          ]
        },

        DeviceNumVOS: {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          tooltip: {
            trigger: 'axis'
          },
          xAxis: {
            type: 'category',
            data: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun']
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              data: [150,230,224,218,135,147,260],
              type: 'line'
            }
          ]
        },
      }
    },
    mounted () {
      this.getList();
      this.base();
    },
    methods: {
      aaa (v) {
        if(!v) {
          this.$message({showClose: true,message: '没有数据',type: 'info'});
          return
        }
        var listData=[]
        v.map((a,i) => {
          var d=a.split(' ');//数据
          d.map((b,ii) => {
            listData.unshift([i,ii,b])
          })
        })

        // d.map((v,i) => {
        //     this.listData.unshift([0,i,v])
        //   });


        this.dialogVisible2=true;

        // prettier-ignore
        var hours=Array.from({length: 65},(_,i) => i);

        var days=Array.from({length: 50},(_,i) => i);



        var option={
          tooltip: {},
          visualMap: {
            max: 64,
            inRange: {
              color: [
                '#7db645',
                '#3f897a',
                '#4c4f8e',
                '#867b90',
                '#f0e03f',
                '#e23e35',
                '#c57198'
              ]
            }
          },
          xAxis3D: {
            name: '相位(°)',
            type: 'category',
            data: hours,
            axisLabel: {
              // 设置刻度为每5个递进
              showMaxLabel: true,
              interval: 16,
              formatter: (value,index) => {
                // 1小时=3600秒
                var d={
                  '8': 45,
                  '16': 90,
                  '24': 135,
                  '32': 180,
                  '40': 225,
                  '48': 270,
                  '56': 315,
                  '64': 360,
                }
                return d[value];
              },
            }
          },
          yAxis3D: {
            name: '周期',
            type: 'category',
            data: days,
            axisLabel: {
              showMaxLabel: true,
              // 设置刻度为每5个递进
              interval: 4
            }
          },
          zAxis3D: {
            name: '相对幅值(V)',
            type: 'value'
          },
          grid3D: {
            boxWidth: 300,
            boxDepth: 200,
            viewControl: {
              projection: 'perspective', // 先设置为这个perspective
              distance: 320,
              // 设置视角的上下旋转角度，取值范围为 -90 ~ 90
              beta: 47,
              // 设置视角的左右旋转角度，取值范围为 -180 ~ 180
              alpha: 5
            },
          },
          series: [
            {
              type: 'bar3D',
              data: listData.map(function(item) {
                return {
                  value: [item[1],item[0],item[2]]
                };
              }),
              shading: 'color',
              label: {
                show: false,
                fontSize: 16,
                borderWidth: 1
              },
              itemStyle: {
                opacity: 0.4
              },
              emphasis: {
                label: {
                  fontSize: 20,
                  color: '#900'
                },
                itemStyle: {
                  color: '#900'
                }
              }
            }
          ]
        };

        setTimeout(() => {
          var proportion=echarts.init(document.getElementById("proportion"));

          proportion.setOption(option,true);
        },300);
      },
      submit () {
        this.$refs['temp'].validate(valid => {
          if(valid) {

            var data={
              "conclusion": this.temp.conclusion,
              "confirmuser": this.$store.userStore.state.nowUserInfo.username,
              "eventstate": 2,
              "no": this.temp.no,
              "picture": this.temp.picture,
            }
            request({url: "/partial/dispose",method: "post",data}).then(res => {
              if(res.code==200) {
                this.dialogVisible=false;
                this.$message({showClose: true,message: '操作成功',type: 'success'});
                this.getList();
              } else {
                if(res.message) {
                  this.$message.error(res.message);
                } else {
                  this.$message.error('操作成功');
                }
              }
            })


          } else {
            return false;
          }
        });
      },
      //编辑弹窗
      edit_ed (v) {
        this.temp=Object.assign({},v);
        this.dialogVisible=true;
        this.$nextTick(() => {
          this.$refs["temp"].clearValidate();
        });
      },
      //上传自定义图标
      icon_fn (file) {
        this.getBase64(file.raw).then(res => {
          this.$set(this.temp,'picture',res)
        })
      },
      getBase64 (file) {
        return new Promise(function(resolve,reject) {
          const reader=new FileReader()
          let imgResult=''
          reader.readAsDataURL(file)
          reader.onload=function() {
            imgResult=reader.result
          }
          reader.onerror=function(error) {
            reject(error)
          }
          reader.onloadend=function() {
            resolve(imgResult)
          }
        })
      },
      changeFn () {
        var d=[];
        var num=[];
        this.list.partialDischargeDeviceNumVOS.map(v => {
          if(v.dayType===this.radio) {
            for(const key in v.deviceNumByDays) {
              num.push(v.deviceNumByDays[key])
              if(this.radio===0) {
                var a=key<10? '0'+key+':00':key+':00';
                d.push(a)
              } else if(this.radio===1) {
                if(key==7) {
                  d.push('周日')
                } else {
                  d.push('周'+key)
                }

              } else if(this.radio===2) {
                d.push(key+'日')
              } else if(this.radio===3) {
                d.push(key+'月')
              }
            }
          }
        })
        this.DeviceNumVOS.xAxis.data=d;
        this.DeviceNumVOS.series[0].data=num;
        if(this.$refs.vchartPie3) {
          this.$refs.vchartPie3.setData(this.DeviceNumVOS);
        }

      },
      base () {
        // 最新的预警详情
        this.tableData=this.list.events;

        // 监测设备占比
        this.roundOption.series[0].data[0].value=this.list.detectionDeviceNum||0;
        this.roundOption.series[0].data[1].value=this.list.undetectedDeviceNum||0;

        this.roundOption.legend.formatter=(name) => {
          const itemValueArr=this.roundOption.series[0].data.filter(el => el.name==name)
          const itemValueAll=this.roundOption.series[0].data.reduce((total,num) => {
            return total+Math.round(num.value);
          },0)
          return `${name} ${(itemValueArr[0].value/itemValueAll*100).toFixed(2)}%  ${itemValueArr[0].value} (台)`
        }



        this.$refs.vchartPie.setData(this.roundOption);
        // 局放设备类型占比 partialDischargeDeviceTypeVOS
        this.roundOption2.series[0].data[0].value=this.list.detectionDeviceProportion||0;
        this.roundOption2.series[0].data[1].value=this.list.undetectedDeviceProportion||0;
        this.list.partialDischargeDeviceTypeVOS.map(v => {
          v.value=v.deviceNum;
          v.name=v.deviceType
        })
        if(this.list.partialDischargeDeviceTypeVOS&&this.list.partialDischargeDeviceTypeVOS.length) {

          this.roundOption2.series[0].data=this.list.partialDischargeDeviceTypeVOS;

          this.roundOption2.legend.formatter=(name) => {
            const itemValueArr=this.list.partialDischargeDeviceTypeVOS.filter(el => el.name==name)
            const itemValueAll=this.list.partialDischargeDeviceTypeVOS.reduce((total,num) => {
              return total+Math.round(num.value);
            },0);
            this.total=itemValueAll;
            return `${name} ${(itemValueArr[0].value/itemValueAll*100).toFixed(2)}%  ${itemValueArr[0].value}(台)`
          }
        };
        this.$refs.vchartPie2.setData(this.roundOption2)

        // 局放预警趋势图
        var d=[];
        var num=[];
        this.list.partialDischargeDeviceNumVOS.map(v => {
          if(v.dayType===this.radio) {
            for(const key in v.deviceNumByDays) {
              num.push(v.deviceNumByDays[key])
              if(this.radio===0) {
                var a=key<10? '0'+key+':00':key+':00';
                d.push(a)
              } else if(this.radio===1) {
                d.push(key)
              } else if(this.radio===2) {
                d.push(key+'日')
              } else if(this.radio===3) {
                d.push(key+'月')
              }
            }
          }
        })
        this.DeviceNumVOS.xAxis.data=d;
        this.DeviceNumVOS.series[0].data=num;
        this.$refs.vchartPie3.setData(this.DeviceNumVOS);
      },

      getList () {
        this.list={
          "earlyWarningByDay": 0,
          "earlyWarningByWeek": 0,
          "earlyWarningByMon": 0,
          "earlyWarningTotal": 8,
          "untreatedByDay": 0,
          "untreatedTotal": 2,
          "detectionDeviceTotal": 8,
          "detectionDit": 1,
          "detectionDeviceNum": 0,
          "detectionDeviceProportion": "0",
          "undetectedDeviceNum": 8,
          "undetectedDeviceProportion": "100",
          "partialDischargeDeviceTypeVOS": [
            {
              "deviceType": "特高频",
              "deviceNum": 0,
              "deviceProportion": "0"
            },
            {
              "deviceType": "超声波",
              "deviceNum": 1,
              "deviceProportion": "13"
            },
            {
              "deviceType": "地电波",
              "deviceNum": 6,
              "deviceProportion": "75"
            },
            {
              "deviceType": "脉冲电流",
              "deviceNum": 1,
              "deviceProportion": "13"
            }
          ],
          "partialDischargeDeviceNumVOS": [
            {
              "dayType": 0,
              "deviceNumByDays": {
                "11": 0,
                "22": 0,
                "12": 0,
                "23": 0,
                "13": 0,
                "14": 0,
                "15": 0,
                "16": 0,
                "17": 0,
                "18": 0,
                "19": 0,
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "20": 0,
                "10": 0,
                "21": 0
              }
            },
            {
              "dayType": 1,
              "deviceNumByDays": {
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0
              }
            },
            {
              "dayType": 2,
              "deviceNumByDays": {
                "22": 0,
                "23": 0,
                "24": 0,
                "25": 0,
                "26": 0,
                "27": 0,
                "28": 0,
                "29": 0,
                "30": 0,
                "31": 0,
                "10": 0,
                "11": 0,
                "12": 0,
                "13": 0,
                "14": 0,
                "15": 0,
                "16": 0,
                "17": 0,
                "18": 0,
                "19": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 0,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "20": 0,
                "21": 0
              }
            },
            {
              "dayType": 3,
              "deviceNumByDays": {
                "11": 0,
                "1": 0,
                "12": 0,
                "2": 0,
                "3": 0,
                "4": 8,
                "5": 0,
                "6": 0,
                "7": 0,
                "8": 0,
                "9": 0,
                "10": 0
              }
            }
          ],
          "events": [
            {
              "no": 30,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "局放设备：1#高频局放恢复正常",
              "time": 1712821279000,
              "confirmuser": null,
              "confirmtime": 1713498506000,
              "conclusion": "2342",
              "picture": "blob:http://localhost:8082/38600d3a-761d-422d-a70a-986f513b9406",
              "jfgraph": [
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "63 63 63 63 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 74 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 63 63 64 64 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64 64",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63",
                "64 64 63 64 64 64 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 64 65 64 64 64 64 64 63 64 64 63 64 64 64 64 64 64 64 64 64 64 63 64 64 64 64 64 64 64 64 64 63"
              ]
            },
            {
              "no": 29,
              "deviceName": "2#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "局放设备：2#高频局放恢复正常",
              "time": 1712816351000,
              "confirmuser": "1",
              "confirmtime": 1713424152000,
              "conclusion": null,
              "picture": null,
              "jfgraph": [
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "76 63 63 70 63 63 65 64 64 64 64 64 63 63 63 64 64 64 65 64 74 64 64 64 64 65 64 64 64 64 74 64 63 63 63 63 65 64 63 63 63 63 65 64 64 64 63 68 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 64",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "63 64 64 64 63 63 63 64 63 63 63 63 75 64 64 67 64 64 65 64 64 64 63 63 64 64 64 63 63 63 64 64 71 64 64 68 64 64 64 80 64 64 62 63 63 63 63 63 65 64 64 63 63 63 64 64 63 63 62 79 63 63 63 63",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64",
                "64 63 63 63 64 64 64 64 64 64 65 64 64 63 63 64 63 63 63 63 63 64 64 64 64 64 64 65 64 64 64 64 66 64 64 65 64 64 65 64 64 65 64 64 64 64 64 63 63 63 65 64 64 64 64 64 64 63 65 64 64 63 64 64"
              ]
            },
            {
              "no": 16,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
              "time": 1712473173000,
              "confirmuser": "2",
              "confirmtime": 1713407222000,
              "conclusion": "111",
              "picture": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAAqCAYAAAAu9HJYAAABt0lEQVRYhe2YvU4CQRCAB7OB49fCRO7QowAOjJEWH8AGgdKK2prKWPAAFsTnoLIUtPEFaDUGObFgIxwkFsrPARJjIwnxB7nbQSXu197szJfdu5nNWVr7CcCCErEnjzQ7JaIujzQHVt4lrETzhEtiwSWx4JJYcEksuCQW6JKUiDp2ToKZDPNSMclCHDfKTgqptFBVm7luo5Gw9p9WAQCGgqfllKRiUPEe9k/zfZb8Fub75M7eZqV0dRZul/2fPa64N2rh2NYuXJxcmy3BdNxCKi1MEwQACLfLfrV0eW5Lpl1m6xBKxJ7RReMPpHrbzE0THKO0b+S76vrRGkDGlKQ80uxGFky2mG69MfO78habMbMphKWvWfVH0UyskY2hRNTJvHrbByyWl8nCRpYytaChfVmD5/vgTLGCpwVDcw2f6et2SlJxHrHvYZIMhLxZ1R2h38WprggNhLxZs3WYJAeFfEeJReMV90btqxjVHaHKdjQ+KOQ7ZuuwTxwYj0XtuFevJ8mgswIAMLK5Hhw+XyGoiAe/PxZ/gP9zCxozOU3+9A8ro2N2FhbiuLkkFlwSCy6JBZfEgkti8Qou35XrqfwBAQAAAABJRU5ErkJggg==",
              "jfgraph": null
            },
            {
              "no": 14,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "通道`设备串口局放`中断",
              "time": 1712473172000,
              "confirmuser": "",
              "confirmtime": 1713151261000,
              "conclusion": "处理成功",
              "picture": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAKTWlDQ1BQaG90b3Nob3AgSUNDIHByb2ZpbGUAAHjanVN3WJP3Fj7f92UPVkLY8LGXbIEAIiOsCMgQWaIQkgBhhBASQMWFiApWFBURnEhVxILVCkidiOKgKLhnQYqIWotVXDjuH9yntX167+3t+9f7vOec5/zOec8PgBESJpHmomoAOVKFPDrYH49PSMTJvYACFUjgBCAQ5svCZwXFAADwA3l4fnSwP/wBr28AAgBw1S4kEsfh/4O6UCZXACCRAOAiEucLAZBSAMguVMgUAMgYALBTs2QKAJQAAGx5fEIiAKoNAOz0ST4FANipk9wXANiiHKkIAI0BAJkoRyQCQLsAYFWBUiwCwMIAoKxAIi4EwK4BgFm2MkcCgL0FAHaOWJAPQGAAgJlCLMwAIDgCAEMeE80DIEwDoDDSv+CpX3CFuEgBAMDLlc2XS9IzFLiV0Bp38vDg4iHiwmyxQmEXKRBmCeQinJebIxNI5wNMzgwAABr50cH+OD+Q5+bk4eZm52zv9MWi/mvwbyI+IfHf/ryMAgQAEE7P79pf5eXWA3DHAbB1v2upWwDaVgBo3/ldM9sJoFoK0Hr5i3k4/EAenqFQyDwdHAoLC+0lYqG9MOOLPv8z4W/gi372/EAe/tt68ABxmkCZrcCjg/1xYW52rlKO58sEQjFu9+cj/seFf/2OKdHiNLFcLBWK8ViJuFAiTcd5uVKRRCHJleIS6X8y8R+W/QmTdw0ArIZPwE62B7XLbMB+7gECiw5Y0nYAQH7zLYwaC5EAEGc0Mnn3AACTv/mPQCsBAM2XpOMAALzoGFyolBdMxggAAESggSqwQQcMwRSswA6cwR28wBcCYQZEQAwkwDwQQgbkgBwKoRiWQRlUwDrYBLWwAxqgEZrhELTBMTgN5+ASXIHrcBcGYBiewhi8hgkEQcgIE2EhOogRYo7YIs4IF5mOBCJhSDSSgKQg6YgUUSLFyHKkAqlCapFdSCPyLXIUOY1cQPqQ28ggMor8irxHMZSBslED1AJ1QLmoHxqKxqBz0XQ0D12AlqJr0Rq0Hj2AtqKn0UvodXQAfYqOY4DRMQ5mjNlhXIyHRWCJWBomxxZj5Vg1Vo81Yx1YN3YVG8CeYe8IJAKLgBPsCF6EEMJsgpCQR1hMWEOoJewjtBK6CFcJg4Qxwicik6hPtCV6EvnEeGI6sZBYRqwm7iEeIZ4lXicOE1+TSCQOyZLkTgohJZAySQtJa0jbSC2kU6Q+0hBpnEwm65Btyd7kCLKArCCXkbeQD5BPkvvJw+S3FDrFiOJMCaIkUqSUEko1ZT/lBKWfMkKZoKpRzame1AiqiDqfWkltoHZQL1OHqRM0dZolzZsWQ8ukLaPV0JppZ2n3aC/pdLoJ3YMeRZfQl9Jr6Afp5+mD9HcMDYYNg8dIYigZaxl7GacYtxkvmUymBdOXmchUMNcyG5lnmA+Yb1VYKvYqfBWRyhKVOpVWlX6V56pUVXNVP9V5qgtUq1UPq15WfaZGVbNQ46kJ1Bar1akdVbupNq7OUndSj1DPUV+jvl/9gvpjDbKGhUaghkijVGO3xhmNIRbGMmXxWELWclYD6yxrmE1iW7L57Ex2Bfsbdi97TFNDc6pmrGaRZp3mcc0BDsax4PA52ZxKziHODc57LQMtPy2x1mqtZq1+rTfaetq+2mLtcu0W7eva73VwnUCdLJ31Om0693UJuja6UbqFutt1z+o+02PreekJ9cr1Dund0Uf1bfSj9Rfq79bv0R83MDQINpAZbDE4Y/DMkGPoa5hpuNHwhOGoEctoupHEaKPRSaMnuCbuh2fjNXgXPmasbxxirDTeZdxrPGFiaTLbpMSkxeS+Kc2Ua5pmutG003TMzMgs3KzYrMnsjjnVnGueYb7ZvNv8jYWlRZzFSos2i8eW2pZ8ywWWTZb3rJhWPlZ5VvVW16xJ1lzrLOtt1ldsUBtXmwybOpvLtqitm63Edptt3xTiFI8p0in1U27aMez87ArsmuwG7Tn2YfYl9m32zx3MHBId1jt0O3xydHXMdmxwvOuk4TTDqcSpw+lXZxtnoXOd8zUXpkuQyxKXdpcXU22niqdun3rLleUa7rrStdP1o5u7m9yt2W3U3cw9xX2r+00umxvJXcM970H08PdY4nHM452nm6fC85DnL152Xlle+70eT7OcJp7WMG3I28Rb4L3Le2A6Pj1l+s7pAz7GPgKfep+Hvqa+It89viN+1n6Zfgf8nvs7+sv9j/i/4XnyFvFOBWABwQHlAb2BGoGzA2sDHwSZBKUHNQWNBbsGLww+FUIMCQ1ZH3KTb8AX8hv5YzPcZyya0RXKCJ0VWhv6MMwmTB7WEY6GzwjfEH5vpvlM6cy2CIjgR2yIuB9pGZkX+X0UKSoyqi7qUbRTdHF09yzWrORZ+2e9jvGPqYy5O9tqtnJ2Z6xqbFJsY+ybuIC4qriBeIf4RfGXEnQTJAntieTE2MQ9ieNzAudsmjOc5JpUlnRjruXcorkX5unOy553PFk1WZB8OIWYEpeyP+WDIEJQLxhP5aduTR0T8oSbhU9FvqKNolGxt7hKPJLmnVaV9jjdO31D+miGT0Z1xjMJT1IreZEZkrkj801WRNberM/ZcdktOZSclJyjUg1plrQr1zC3KLdPZisrkw3keeZtyhuTh8r35CP5c/PbFWyFTNGjtFKuUA4WTC+oK3hbGFt4uEi9SFrUM99m/ur5IwuCFny9kLBQuLCz2Lh4WfHgIr9FuxYji1MXdy4xXVK6ZHhp8NJ9y2jLspb9UOJYUlXyannc8o5Sg9KlpUMrglc0lamUycturvRauWMVYZVkVe9ql9VbVn8qF5VfrHCsqK74sEa45uJXTl/VfPV5bdra3kq3yu3rSOuk626s91m/r0q9akHV0IbwDa0b8Y3lG19tSt50oXpq9Y7NtM3KzQM1YTXtW8y2rNvyoTaj9nqdf13LVv2tq7e+2Sba1r/dd3vzDoMdFTve75TsvLUreFdrvUV99W7S7oLdjxpiG7q/5n7duEd3T8Wej3ulewf2Re/ranRvbNyvv7+yCW1SNo0eSDpw5ZuAb9qb7Zp3tXBaKg7CQeXBJ9+mfHvjUOihzsPcw83fmX+39QjrSHkr0jq/dawto22gPaG97+iMo50dXh1Hvrf/fu8x42N1xzWPV56gnSg98fnkgpPjp2Snnp1OPz3Umdx590z8mWtdUV29Z0PPnj8XdO5Mt1/3yfPe549d8Lxw9CL3Ytslt0utPa49R35w/eFIr1tv62X3y+1XPK509E3rO9Hv03/6asDVc9f41y5dn3m978bsG7duJt0cuCW69fh29u0XdwruTNxdeo94r/y+2v3qB/oP6n+0/rFlwG3g+GDAYM/DWQ/vDgmHnv6U/9OH4dJHzEfVI0YjjY+dHx8bDRq98mTOk+GnsqcTz8p+Vv9563Or59/94vtLz1j82PAL+YvPv655qfNy76uprzrHI8cfvM55PfGm/K3O233vuO+638e9H5ko/ED+UPPR+mPHp9BP9z7nfP78L/eE8/sl0p8zAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAARISURBVHja7JhdbNtUFIDPtZ3EdhK3+WviJGNZOlY0EBp7GIgnHpiEKP/rtKE9UFZWiQ3xUIkJNKCs20CMh2pC66QNKiR+BWxIqBNiLxsPCE2IwZA6WGlLtjaJU6dJ4ySOnfqHh5CSdI3atEnXop6ne61zjz+fn+t7D5p44VEdVoFgsEpkDbTWQhQHCbJJYo9/uG4Z3skDgGMhitzBvWM2iafLQDUM1+SXH4/X1St7X/OHvjkH67Y/7NS/PDk0n75Ge7RbPFpvYfoGyPhLO276NRmiP9IfewDuX5E5+ieXf8CoyShm2xi+p/vogyuzmEzUZW/PMxctJwcs7uSwP97Zqq48UBN1GeTcNsDws5kDj2ULCUe0KWzw1KKqvi5CmS9ALrsNABBoBSfm2eZ+nAu1E9FRBC7fOPDhY7fXowXI7YATfYU3Yc8JtCthjI48j+sqAgDIpjKHbkvoVd/G46K3ZUD3Bd+YgVSVAwAA4PA0MSJvKwunKpkcp8/jywqKSOopPDz8Ch253johET3IbN05AwkAwEfeSzuDv5eBaio2eajzVWQw7lo20JTV91Zx7J4cAsnuf2K2jnXq5hHBEfhDQYXSwHUFgA8flTT02TQbPF13UNVApTGBvyttKkRWJCwKKcS+v0VRUb5mJkObJecdv5RtDKqMGaKj+xBJ76kbqGqg0vh0zmKRUyZczSt5f0s/rWQMeirxacU1suyrsJUxdQEtQhbnpBEfNI5f76iYxyZyt+AIXGsQwp65aTCi5vvobEiNZq5iorClkr7svfMrY2S4jZFDFW3qSf79mnq0Kki3//W0yS6aIn+1Ifjv1iN5mr8VLJ6JMruewImagS4UEpH0npRt/SjExo9Y5QRVfC5YPDFkaegguZEnmQznBoLYKeOUAgCQ17GWmoAuFDLHbvpOl8RPGpI3NszoIkyfZoNnmAzn0TOp/tKdQHV6LwEAIABpyaAazVyZD1JjA29nDdY8FR16pPS50OAP4QTxrCE62jlnsSP1GgAAqYg/LLmYMFHYClBIstmQyNrYkcSsPY3RkNdcsiaPGTW8yXuC4UJd89zJ1YzJJlomud5a5SgCkj5XCim6my/q6akPGlNj3lLFtH39oBHTduFcqGs+o1P7ez+njn10d22PeZK4oyTU79LRkYfK8pMwT5MO+zvW2I3uhZp0vPn0z3X91+MJ7tfSeda14ScK5N0oNtYNNZYlHZx1WfpCYwP38Sp90K0musz83711v9c7xSgd9m4dXIwRkXGAmjW2A+tpryWcN/qbZU6P+iJXNi/B7r1rLZ1V1XuKsFuuLqrzIYSH8iarrZo1RjmdFBjfpkVddXRdXx0erboVt6/1309EL4Ku91XnFrQfdP0UAIDrzPllylEna1uWNWtVvwZapaRpVzxHmGUpkTxc9cErkTycI8xymnbF6171dC5hLza5qhVSzREAAKoq2f+3of9nAPluuxwhb5rwAAAAAElFTkSuQmCC",
              "jfgraph": null
            },
            {
              "no": 13,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯恢复",
              "time": 1712125854000,
              "confirmuser": null,
              "confirmtime": 1713256667000,
              "conclusion": "测试",
              "picture": "blob:http://192.168.124.16:8081/4a34cf9e-3950-45cb-9696-0e8b842f0565",
              "jfgraph": null
            },
            {
              "no": 12,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "通道`设备串口局放`恢复",
              "time": 1712125835000,
              "confirmuser": "1",
              "confirmtime": 1712974300000,
              "conclusion": "已经处理",
              "picture": "",
              "jfgraph": null
            },
            {
              "no": 3,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "数据采集通道`设备串口局放` 局放主机 通讯中断",
              "time": 1712111145000,
              "confirmuser": "",
              "confirmtime": null,
              "conclusion": null,
              "picture": null,
              "jfgraph": null
            },
            {
              "no": 1,
              "deviceName": "1#高频局放",
              "devicePoint": "前山变电站1#开关柜",
              "description": "通道`设备串口局放`中断",
              "time": 1712111144000,
              "confirmuser": "",
              "confirmtime": null,
              "conclusion": null,
              "picture": null,
              "jfgraph": null
            }
          ]
        };
        this.base();
      },
    }
  }
</script>

<style lang="scss" scoped>
  .line {
    border: 1px solid #000;
    position: relative;
  }

  .line .grouped {
    position: absolute;
    right: 100px;
    top: 20px;
    z-index: 9;
  }

  .pie {
    display: flex;
    position: relative;

    .titled {
      border-left: 5px solid #2c73ff;
      padding-left: 8px;
      position: absolute;
      z-index: 9;
      left: 10px;
      top: 6px;
      font-weight: bold;
    }

    .txt {
      position: absolute;
      top: 41%;
      left: 21.5%;
      z-index: 9;
      text-align: center;

      .num {
        font-size: 30px;
        font-weight: bold;
        margin-bottom: 5px;
      }
    }

    >div {
      flex: 1;
      height: 100%;
      border: 1px solid #000;
      position: relative;
    }
  }

  .platform_box {
    background-color: #fff;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        border: 1px solid #000;
        padding: 5px;
        width: 70%;
        justify-content: space-around;

        .img {
          width: 28px;
          -o-object-fit: contain;
          object-fit: contain;
          margin-right: 4px;
          background: #e5929382;
          border-radius: 50%;
          height: 28px;
          padding: 6px;
        }

        .img2 {
          width: 25px;
          margin-right: 4px;
          background: #f8ab124d;
          border-radius: 13px;
          height: 25px;
          padding: 7px;
          object-fit: contain;
        }
      }

      .right {
        display: flex;
        border: 1px solid #000;
        padding: 5px;
        width: 28%;
        justify-content: space-around;

        .img {
          width: 32px;
          object-fit: contain;
          margin-right: 10px;
        }
      }

      .text_box {
        display: flex;

        .txt {
          display: flex;
          flex-direction: column;
          align-items: center;

          span {
            white-space: nowrap;
          }
        }
      }
    }
  }

  #proportion {
    height: 500px;
    width: 100%;
  }
</style>